export default __webpack_public_path__ + "static/media/team36.97629ae3.JPG";